var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }